"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Owners = require("../Owners/");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    borderTop: "1px solid",
    borderColor: "#ccc",
    position: "relative"
  },
  list: {
    height: theme.spacing(7 * 8)
  }
}));

const AppsOwnersList = ({
  owners = [],
  onSelect
}) => {
  const classes = useStyles();

  if (owners.length > 7) {
    return _react.default.createElement("section", {
      className: classes.root
    }, _react.default.createElement(_Owners.FilterOwnersControlled, {
      className: classes.list,
      owners: owners,
      onSelect: onSelect
    }));
  }

  return _react.default.createElement("section", {
    className: classes.root
  }, _react.default.createElement(_Owners.OwnersList, {
    owners: owners,
    onSelect: onSelect
  }));
};

var _default = AppsOwnersList;
exports.default = _default;
module.exports = exports.default;